import React, { useState, useEffect } from 'react';
import {
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Typography,
  Box,
} from '@mui/material';

const NewCheckDetailsFormRenderer = ({ data }) => {
  const initializeFormData = () => {
    const lhs = data?.lhs || [];
    const rhs = data?.rhs || [];
    const allFields = [...lhs, ...rhs];
    const initialData = {};

    allFields.forEach((item) => {
      initialData[item.field] = item.value ?? '';
    });

    // Default fields for Case Details
    ['case_id', 'candidate_name_or_company', 'client_name', 'check_type'].forEach((key) => {
      initialData[key] = initialData[key] ?? '';
    });

    return initialData;
  };

  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData(initializeFormData());
  }, [data]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const renderField = (item) => {
    const commonProps = {
      fullWidth: true,
      label: item.label,
      value: formData[item.field] ?? '',
      onChange: (e) => handleChange(item.field, e.target.value),
      margin: 'normal',
    };

    if (item.type === 'text') {
      return <TextField key={item.field} {...commonProps} />;
    } else if (item.type === 'dropdown') {
      const labelId = `label-${item.field}`;
      const selectId = `select-${item.field}`;

      return (
        <FormControl fullWidth margin="normal" key={item.field}>
          <InputLabel id={labelId}>{item.label}</InputLabel>
          <Select
            id={selectId}
            labelId={labelId}
            value={formData[item.field] ?? ''}
            label={item.label}
            onChange={(e) => handleChange(item.field, e.target.value)}
          >
            {(item.options || []).map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    return null;
  };

  const renderSection = (title, fields) => (
    <Box key={title} sx={{ mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {fields.map((item) => (
          <Grid item xs={12} sm={6} key={item.field}>
            {renderField(item)}
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  // Group fields by section
  const allFields = [...(data?.lhs || []), ...(data?.rhs || [])];
  const grouped = {};
  for (const item of allFields) {
    const group = item.detailsSection || 'Other';
    if (!grouped[group]) grouped[group] = [];
    grouped[group].push(item);
  }

  const caseDetailsFields = [
    { field: 'case_id', label: 'Case ID', type: 'text' },
    { field: 'candidate_name_or_company', label: 'Candidate/Company Name', type: 'text' },
    { field: 'client_name', label: 'Client Name', type: 'text' },
    { field: 'check_type', label: 'Check Type', type: 'text' },
  ];
  return (
    <Box p={3}>
      {Object.entries(grouped).map(([section, fields]) =>
        renderSection(section, fields)
      )}
    </Box>
  );  

};

export default NewCheckDetailsFormRenderer;
